export default "__VITE_ASSET__dTdlKXIp__"